var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Auth0ClientService } from '../../../core/services/auth0-client.service';
import { TeamService } from '../../../core/services/team.service';
export class Auth0CallbackComponent {
    constructor(auth0, http, router, teamService) {
        this.auth0 = auth0;
        this.http = http;
        this.router = router;
        this.teamService = teamService;
        this.error = null;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const teamCode = this.teamService.teamTemplate ? this.teamService.teamTemplate.teamId : '';
            try {
                const appState = yield this.auth0.handleRedirectCallback();
                const returnTo = (appState && appState.returnTo)
                    || (teamCode ? `${teamCode}/main` : '');
                // Probe the API once to find out whether the Auth0 sub is already linked to a
                // customer record. The RequireLinkedCustomerFilter on the API responds with
                // HTTP 403 + ErrorCode=AUTH0_LINK_REQUIRED when linking is still needed.
                try {
                    yield this.http.get('core-api/Ticketing/Portals/GetPortalRequiredSettings').toPromise();
                    yield this.router.navigateByUrl(returnTo);
                }
                catch (err) {
                    if (err instanceof HttpErrorResponse
                        && err.status === 403
                        && this.isLinkRequiredResponse(err)) {
                        yield this.router.navigateByUrl(`${teamCode}/auth0-link`, {
                            state: { returnTo }
                        });
                    }
                    else {
                        this.error = 'Sign-in completed but the server rejected the request. Please try again.';
                    }
                }
            }
            catch (err) {
                this.error = 'Sign-in did not complete. Please try again.';
            }
        });
    }
    isLinkRequiredResponse(err) {
        const body = err.error;
        if (!body) {
            return false;
        }
        const code = body.errorCode || body.ErrorCode || (body.data && body.data.errorCode);
        return code === 'AUTH0_LINK_REQUIRED';
    }
}
